<div class="hx-native-select__wrapper">
  <select
    #selectRef
    class="hx-native-select__select"
    [attr.aria-describedby]="ariaDescribedBy() || null"
    [attr.aria-invalid]="error() ? 'true' : null"
    [attr.aria-label]="ariaLabel() || null"
    [attr.aria-labelledby]="ariaLabelledBy() || null"
    [attr.aria-readonly]="readonly()"
    [disabled]="disabled() || readonly()"
    [value]="value() || ''"
    (blur)="onBlur($event)"
    (change)="onNativeChange($event)"
    (focus)="onFocus($event)">
    <!-- Placeholder option -->
    @if (placeholder()) {
      <option
        value=""
        [disabled]="true"
        [selected]="!hasValue()">
        {{ placeholder() }}
      </option>
    }

    <!-- Render options (ungrouped or grouped) -->
    @for (item of options(); track item.id) {
      @if (isOptionGroup(item)) {
        <!-- Option group -->
        <optgroup
          [disabled]="item.disabled || false"
          [label]="item.label">
          @for (option of item.options; track option.id) {
            <option
              [disabled]="option.disabled || false"
              [selected]="value() === option.value"
              [value]="option.value">
              {{ option.label }}
            </option>
          }
        </optgroup>
      } @else {
        <!-- Single option -->
        <option
          [disabled]="item.disabled || false"
          [selected]="value() === item.value"
          [value]="item.value">
          {{ item.label }}
        </option>
      }
    }
  </select>

  <!-- Dropdown icon -->
  <div
    aria-hidden="true"
    class="hx-native-select__icon">
    <svg
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5" />
    </svg>
  </div>
</div>
